import React, {
  useEffect,
  useState,
  useCallback,
  useRef,
  useMemo,
} from "react";
import { FaUndo } from "react-icons/fa";
import { IoExitOutline } from "react-icons/io5";
import { API_HOST } from "../../api_utils";
import axios from "axios";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { Box, Divider, Modal } from "@mui/material";
import Loader from "../../Shared_Components/Loader";
import { RiSave2Fill } from "react-icons/ri";
import { TbArrowBackUp } from "react-icons/tb";

function Stamp(props) {
  const { userDataFromStorage, coloredTheme } = props;
  const [tabCount, setTabCount] = useState(0);

  // filter states for owed to agent:
  const [owedAgent, setOwedAgent] = useState("");
  const [owedManager, setOwedManager] = useState("");
  const [owedLoanAfter, setOwedLoanAfter] = useState(null);

  const singaporeTimezone = "Asia/Singapore";
  const currentDateInSingapore = new Date().toLocaleDateString("en-US", {
    timeZone: singaporeTimezone,
  });
  const [owedLoanBefore, setOwedLoanBefore] = useState(
    formatDate(currentDateInSingapore)
  );

  function formatDate(dateString) {
    const [month, day, year] = dateString.split("/");
    const formattedMonth = month.padStart(2, "0");
    const formattedDay = day.padStart(2, "0");
    return `${year}-${formattedMonth}-${formattedDay}`;
  }

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  // states for storing response for tables:
  const [owedByAgentData, setOwedByAgentData] = useState([]);
  const [owedToAgentModel, setOwedToAgentModel] = useState(false);
  const [owedToAgentModalData, setOwedToAgentModalData] = useState({});
  const [owedToAgentCommissionDate, setOwedToAgentCommissionDate] =
    useState("");
  const [owedToAgentLoading, setOwedToAgentLoading] = useState(false);

  const [agentNameForApi, setAgentNameForApi] = useState("");
  const [selectedAgentName, setSelectedAgentName] = useState("");
  const [managerNameForApi, setManagerNameForApi] = useState("");
  const [selectedManagerName, setSelectedManagerName] = useState("");
  const [managerNameList, setManagerNameList] = useState([]);
  const [agentNameList, setAgentNameList] = useState([]);

  const searchFilterOptionsShowAgent = useRef(true);
  const searchFilterOptionsShowManager = useRef(true);

  const getCnnyStartDateHandler = async () => {
    const { data } = await axios.get(
      `${API_HOST}/api/users/get_cnny_start_date_report`
    );
    if (data) {
      if (!data.message) {
        console.log("data::::", data);
        setOwedLoanAfter(
          new Date(data[0].cn_ny_start).toISOString().split("T")[0]
        );
      }
    }
  };

  useEffect(() => {
    getCnnyStartDateHandler();
  }, []);

  // getManagerAPI:
  const getStampClaimListApi = async () => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage.token}`,
      },
    };

    let apiUrl = `${API_HOST}/api/loan_header/get_owed_to_agent?page=${currentPage}&pageSize=${pageSize}`;

    const queryParams = [];
    if (agentNameForApi) {
      queryParams.push(`agent_name=${agentNameForApi}`);
    }
    if (managerNameForApi) {
      queryParams.push(`manager_name=${managerNameForApi}`);
    }

    if (owedLoanBefore) {
      queryParams.push(`loan_before=${owedLoanBefore}`);
    }

    if (owedLoanAfter) {
      queryParams.push(`loan_after=${owedLoanAfter}`);
    }

    if (queryParams.length > 0) {
      const queryString = queryParams.join("&");
      apiUrl += `&${queryString}`;
    }

    const { data } = await axios.get(apiUrl, config);
    if (data) {
      if (!data.message) {
        console.log("data", data);
        setOwedByAgentData(data);
      }
    }
  };

  const getAllManagerNames = async () => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage?.token}`,
      },
    };

    let apiUrl = `${API_HOST}/api/users/manager_name_list`;

    const { data } = await axios.get(apiUrl, config);
    if (!data.message) {
      setManagerNameList(data);
    }
  };

  const getAllAgentNames = async () => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage?.token}`,
      },
    };

    let apiUrl = `${API_HOST}/api/users/agent_name_list`;

    const { data } = await axios.get(apiUrl, config);
    if (!data.message) {
      setAgentNameList(data);
    }
  };

  useEffect(() => {
    const el = document.getElementById("tab0");
    const el1 = document.getElementById("tab1");
    const el2 = document.getElementById("tab2");
    const el3 = document.getElementById("tab3");
    const el4 = document.getElementById("tab4");
    if (tabCount === 0) {
      el.style.backgroundColor = "white";
      el1.style.backgroundColor = "transparent";
      el2.style.backgroundColor = "transparent";
      el3.style.backgroundColor = "transparent";
      el4.style.backgroundColor = "transparent";
    } else if (tabCount === 1) {
      el.style.backgroundColor = "transparent";
      el1.style.backgroundColor = "white";
      el2.style.backgroundColor = "transparent";
      el3.style.backgroundColor = "transparent";
      el4.style.backgroundColor = "transparent";
    } else if (tabCount === 2) {
      el.style.backgroundColor = "transparent";
      el1.style.backgroundColor = "transparent";
      el2.style.backgroundColor = "white";
      el3.style.backgroundColor = "transparent";
      el4.style.backgroundColor = "transparent";
    } else if (tabCount === 3) {
      el.style.backgroundColor = "transparent";
      el1.style.backgroundColor = "transparent";
      el2.style.backgroundColor = "transparent";
      el3.style.backgroundColor = "white";
      el4.style.backgroundColor = "transparent";
    } else {
      el.style.backgroundColor = "transparent";
      el1.style.backgroundColor = "transparent";
      el2.style.backgroundColor = "transparent";
      el3.style.backgroundColor = "transparent";
      el4.style.backgroundColor = "white";
    }
  }, [tabCount]);

  useEffect(() => {
    getAllManagerNames();
    getAllAgentNames();
  }, []);

  useEffect(() => {
    if (owedLoanAfter && owedLoanBefore) {
      getStampClaimListApi();
    }
  }, [
    currentPage,
    managerNameForApi,
    agentNameForApi,
    owedLoanBefore,
    owedLoanAfter,
  ]);

  const addPaymentCommissionHandler = () => {};

  const handleManagerNameChange = useCallback((e) => {
    setOwedManager(e.target.value);
  }, []);

  const handleAgentNameChange = useCallback((e) => {
    setOwedAgent(e.target.value);
  }, []);

  const filteredAgentOptions = useMemo(() => {
    if (owedAgent && !selectedAgentName) {
      console.log("here");
      const searchTerm = owedAgent.toLowerCase();
      const optionsStartingWithSearchTerm = [];

      console.log("searchTerm", searchTerm);

      agentNameList.forEach((option) => {
        if (
          option.agent_name &&
          option.agent_name.toLowerCase().startsWith(searchTerm)
        ) {
          console.log(
            "option.agent_name.toLowerCase().startsWith(searchTerm)",
            option.agent_name.toLowerCase().startsWith(searchTerm)
          );
          optionsStartingWithSearchTerm.push(option);
        }
      });

      optionsStartingWithSearchTerm.sort((a, b) =>
        a.agent_name.localeCompare(b.agent_name, undefined, {
          sensitivity: "base",
        })
      );

      console.log(
        "optionsStartingWithSearchTerm",
        optionsStartingWithSearchTerm
      );

      // setAgentLastName("");

      return optionsStartingWithSearchTerm;
    } else {
      console.log("here agent");
      if (selectedAgentName) {
        console.log("here agent1111");
        setAgentNameForApi(selectedAgentName);
        setSelectedAgentName("");

        searchFilterOptionsShowAgent.current = false;
      } else {
        console.log("here agent222");
        searchFilterOptionsShowAgent.current = true;
      }

      return [];
    }
  }, [owedAgent, selectedAgentName]);

  const filteredManagerOptions = useMemo(() => {
    if (owedManager && !selectedManagerName) {
      console.log("here");
      const searchTerm = owedManager.toLowerCase();
      const optionsStartingWithSearchTerm = [];

      console.log("searchTerm", searchTerm);

      managerNameList.forEach((option) => {
        if (
          option.manager_name &&
          option.manager_name.toLowerCase().startsWith(searchTerm)
        ) {
          console.log(
            "option.manager_name.toLowerCase().startsWith(searchTerm)",
            option.manager_name.toLowerCase().startsWith(searchTerm)
          );
          optionsStartingWithSearchTerm.push(option);
        }
      });

      optionsStartingWithSearchTerm.sort((a, b) =>
        a.manager_name.localeCompare(b.manager_name, undefined, {
          sensitivity: "base",
        })
      );

      console.log(
        "optionsStartingWithSearchTerm",
        optionsStartingWithSearchTerm
      );

      // setAgentLastName("");

      return optionsStartingWithSearchTerm;
    } else {
      console.log("here agent");
      if (selectedManagerName) {
        setManagerNameForApi(selectedManagerName);
        setSelectedManagerName("");

        searchFilterOptionsShowManager.current = false;
      } else {
        searchFilterOptionsShowManager.current = true;
      }

      return [];
    }
  }, [owedManager, selectedManagerName]);

  return (
    <div
      className={
        userDataFromStorage.user_role === "admin"
          ? "xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[1rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[15%]  xl:mt-[9%] mt-[20%] bg-blue-50  overflow-hidden"
          : "xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[1rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[10%]  xl:mt-[5%] mt-[20%] bg-blue-50 overflow-hidden"
      }>
      <p className="text-gray-800 xl:text-[1.8rem] lg:text-[1.5rem] text-[1.2rem] tracking-wider">
        Customer Stamp Duty Plus Agent Stamp Commission & Claims Reports
      </p>

      <div className="mt-6 ">
        <div className="overflow-scroll">
          <div className="flex lg:text-[1rem] md:text-[0.8rem] text-[0.8rem] justify-start items-center  w-[150%] md:w-[100%] ">
            <button
              id="tab0"
              onClick={() => setTabCount(0)}
              className=" px-[1rem] w-[50vw] md:w-fit py-[0.5rem] bg-white ">
              Accrual By Customer
            </button>
            <button
              id="tab1"
              onClick={() => setTabCount(1)}
              className="w-[50vw] md:w-fit px-[1rem] py-[0.5rem] ">
              Accrual By Agent
            </button>
            <button
              id="tab2"
              onClick={() => setTabCount(2)}
              className="w-[50vw] md:w-fit px-[1rem] py-[0.5rem] ">
              Owed To Agent
            </button>
            <button
              id="tab3"
              onClick={() => setTabCount(3)}
              className="w-[50vw] md:w-fit px-[1rem] py-[0.5rem] ">
              Paid To Agent
            </button>
            <button
              id="tab4"
              onClick={() => setTabCount(4)}
              className="w-[50vw] md:w-fit px-[1rem] py-[0.5rem] ">
              Claims By Agent
            </button>
          </div>
        </div>
        {tabCount === 0 ? (
          <>
            <div
              style={{ backgroundColor: coloredTheme }}
              className="px-[0.5rem] md:text-[1rem] text-[0.8rem] py-[1rem]  text-white space-y-2">
              <p>Total Customer Stamp Duty reported is MYR </p>
              <p>Total Agent Stamp Commission reported is MYR </p>
            </div>
            <div className="px-[0.5rem] py-[1rem]  bg-white">
              <div className="md:flex justify-start items-center ">
                <p className="w-[25rem]">Manager Last Name</p>
                <input
                  type="text"
                  className="outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0"
                />
              </div>
              <div className="md:flex justify-start items-center mt-6">
                <p className="w-[25rem]">Customer Nickname </p>
                <input
                  type="text"
                  className="outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0"
                />
              </div>
              <div className="md:flex justify-start items-center mt-6">
                <p className="w-[25rem]">Loan Start Date From </p>
                <input
                  type="date"
                  className="outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0"
                />
              </div>
              <div className="md:flex justify-start items-center mt-6">
                <p className="w-[25rem]">Loan Start Date To </p>
                <input
                  type="date"
                  className="outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0"
                />
              </div>
              <div className="md:flex justify-start items-center mt-6">
                <p className="w-[25rem]">
                  Show if Stamp Commission paid to the Agent
                </p>
                <div className="flex items-center ">
                  <input type={"radio"} id="Senior" />
                  <label className="ml-1 mr-6" htmlFor="Senior">
                    Senior Agent
                  </label>
                  <input type={"radio"} id="Agent" />
                  <label className="ml-1" htmlFor="Agent">
                    Agent
                  </label>
                </div>
              </div>
              <button
                style={{ backgroundColor: coloredTheme }}
                className="flex justify-center items-center  rounded space-x-2 px-[1rem] py-[0.5rem] mt-6 text-white">
                <FaUndo />
                <p>Reset</p>
              </button>
            </div>

            <div className="mt-8 bg-white pb-[1.5rem]">
              <div className="overflow-scroll px-[0.5rem]">
                <table className="md:w-[100%] xl:w-[110%] w-[180%] ">
                  <thead className="h-[6vh]">
                    <tr className="border border-gray-400">
                      <th className="text-start border-r  border-gray-400 px-[0.2rem]">
                        Customer Nickname
                      </th>
                      <th className="text-start border-r  border-gray-400 px-[0.2rem]">
                        Manager's Name
                      </th>
                      <th className="text-start border-r  border-gray-400 px-[0.2rem]">
                        Agent Name
                      </th>
                      <th className="text-start border-r  border-gray-400 px-[0.2rem]">
                        Loan Number
                      </th>
                      <th className="text-start border-r  border-gray-400 px-[0.2rem]">
                        Loan Start Date{" "}
                      </th>
                      <th className="text-start border-r  border-gray-400 px-[0.2rem]">
                        Loan Amount
                      </th>
                      <th className="text-start border-r  border-gray-400 px-[0.2rem]">
                        Customer Stamp Duty
                      </th>
                      <th className="text-start border-r  border-gray-400 px-[0.2rem]">
                        Agent Stamp Commission
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {owedByAgentData.length
                      ? owedByAgentData.map((x, index) => {
                          let date = new Date(x?.loan_start_date);
                          let day = String(date?.getUTCDate()).padStart(2, "0");
                          let month = String(date?.getUTCMonth() + 1).padStart(
                            2,
                            "0"
                          );
                          let year = String(date?.getUTCFullYear());
                          let modifiedLoanStartDate = `${day}-${month}-${year}`;

                          return (
                            <tr key={index} className="border border-gray-400">
                              <td className="text-start border-l border-t border-r border-gray-400 px-[0.2rem]">
                                {x.customer_nickname}
                              </td>
                              <td className="text-start border-l border-t border-r border-gray-400 px-[0.2rem]">
                                {x.manager}
                              </td>
                              <td className="text-start border-t border-r border-gray-400 px-[0.2rem]">
                                {x.agent}
                              </td>
                              <td className="text-start border-t border-r border-gray-400 px-[0.2rem]">
                                {x.loan_number}
                              </td>
                              <td className="text-start border-t border-r border-gray-400 px-[0.2rem]">
                                {modifiedLoanStartDate}
                              </td>
                              <td className="text-start border-t border-r border-gray-400 px-[0.2rem]">
                                MYR {x.loan_amount}
                              </td>
                              <td className="text-start border-t border-r border-gray-400 px-[0.2rem]">
                                {x.customer_stamp_duty}
                              </td>
                              <td className="text-start border-t border-r border-gray-400 px-[0.2rem]">
                                {" "}
                                {x.agent_stamp_commission}
                              </td>
                            </tr>
                          );
                        })
                      : ""}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        ) : tabCount === 1 ? (
          <>
            <div
              style={{ backgroundColor: coloredTheme }}
              className="px-[0.5rem] md:text-[1rem] text-[0.8rem] py-[1rem]  text-white space-y-2">
              <p>Total Customer Stamp Duty reported is MYR </p>
              <p>Total Agent Stamp Commission reported is MYR </p>
            </div>
            <div className="px-[0.5rem] py-[1rem]  bg-white">
              <div className="md:flex justify-start items-center ">
                <p className="w-[25rem]">Manager Last Name</p>
                <input
                  type="text"
                  className="outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0"
                />
              </div>
              <div className="md:flex justify-start items-center mt-6">
                <p className="w-[25rem]">Customer Nickname </p>
                <input
                  type="text"
                  className="outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0"
                />
              </div>
              <div className="md:flex justify-start items-center mt-6">
                <p className="w-[25rem]">Loan Start Date From </p>
                <input
                  type="date"
                  className="outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0"
                />
              </div>
              <div className="md:flex justify-start items-center mt-6">
                <p className="w-[25rem]">Loan Start Date To </p>
                <input
                  type="date"
                  className="outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0"
                />
              </div>
              <div className="md:flex justify-start items-center mt-6">
                <p className="w-[25rem]">
                  Show if Stamp Commission paid to the Agent
                </p>
                <div className="flex items-center ">
                  <input type={"radio"} id="Senior" />
                  <label className="ml-1 mr-6" htmlFor="Senior">
                    Senior Agent
                  </label>
                  <input type={"radio"} id="Agent" />
                  <label className="ml-1" htmlFor="Agent">
                    Agent
                  </label>
                </div>
              </div>
              <button
                style={{ backgroundColor: coloredTheme }}
                className="flex justify-center items-center  rounded space-x-2 px-[1rem] py-[0.5rem] mt-6 text-white">
                <FaUndo />
                <p>Reset</p>
              </button>
            </div>

            <div className="mt-8 bg-white pb-[1.5rem]">
              <div className="overflow-scroll px-[0.5rem]">
                <table className="md:w-[100%] xl:w-[110%] w-[180%] ">
                  <thead className="h-[6vh]">
                    <tr className="border border-gray-400">
                      <th className="text-start border-r  border-gray-400 px-[0.2rem]">
                        Agent Name
                      </th>
                      <th className="text-start border-r  border-gray-400 px-[0.2rem]">
                        Manager's Name
                      </th>
                      <th className="text-start border-r  border-gray-400 px-[0.2rem]">
                        Loan Number
                      </th>
                      <th className="text-start border-r  border-gray-400 px-[0.2rem]">
                        Loan Start Date{" "}
                      </th>
                      <th className="text-start border-r  border-gray-400 px-[0.2rem]">
                        Loan Amount
                      </th>
                      <th className="text-start border-r  border-gray-400 px-[0.2rem]">
                        Customer Stamp Duty
                      </th>
                      <th className="text-start border-r  border-gray-400 px-[0.2rem]">
                        Agent Stamp Commission
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {owedByAgentData.length
                      ? owedByAgentData.map((x, index) => {
                          let date = new Date(x?.loan_start_date);
                          let day = String(date?.getUTCDate()).padStart(2, "0");
                          let month = String(date?.getUTCMonth() + 1).padStart(
                            2,
                            "0"
                          );
                          let year = String(date?.getUTCFullYear());
                          let modifiedLoanStartDate = `${day}-${month}-${year}`;

                          return (
                            <tr key={index} className="border border-gray-400">
                              <td className="text-start border-t border-r border-gray-400 px-[0.2rem]">
                                {x.agent}
                              </td>
                              <td className="text-start border-l border-t border-r border-gray-400 px-[0.2rem]">
                                {x.manager}
                              </td>
                              <td className="text-start border-t border-r border-gray-400 px-[0.2rem]">
                                {x.loan_number}
                              </td>
                              <td className="text-start border-t border-r border-gray-400 px-[0.2rem]">
                                {modifiedLoanStartDate}
                              </td>
                              <td className="text-start border-t border-r border-gray-400 px-[0.2rem]">
                                MYR {x.loan_amount}
                              </td>
                              <td className="text-start border-t border-r border-gray-400 px-[0.2rem]">
                                MYR {x.customer_stamp_duty}
                              </td>
                              <td className="text-start border-t border-r border-gray-400 px-[0.2rem]">
                                {" "}
                                MYR {x.agent_stamp_commission}
                              </td>
                            </tr>
                          );
                        })
                      : ""}
                  </tbody>
                </table>
              </div>
              {/* PAGINATION */}
            </div>
          </>
        ) : tabCount === 2 ? (
          <>
            <div
              style={{ backgroundColor: coloredTheme }}
              className="px-[0.5rem] md:text-[1rem] text-[0.8rem] py-[1rem]  text-white space-y-2">
              <p>
                Stamp Commission currently Owed to Agent; i.e. Loan is Closed
                and Stamp Duty not yet paid. Total Stamp Commission for this
                report is MYR{" "}
              </p>
            </div>
            <div className="px-[0.5rem] py-[1rem]  bg-white">
              <div className="relative md:flex justify-start items-center mt-6">
                <p className="w-[30%]">Manager Last Name</p>
                <input
                  type="text"
                  value={owedManager}
                  placeholder="Enter Manager Last Name"
                  onInput={(e) => {
                    console.log("e.target::::::", e.target.value);
                    handleManagerNameChange(e);
                  }}
                  className="outline-none  border border-gray-300 rounded-lg  w-[70%]   p-[0.8rem] "
                />
                {filteredManagerOptions.length > 0 && (
                  <div
                    className={
                      searchFilterOptionsShowManager?.current
                        ? "absolute 2xl:top-[4rem] lg:top-[4rem] lg:max-h-[12rem] xl:top-[4rem] xl:max-h-[12rem] 2xl:max-h-[13rem] overflow-y-scroll w-[100%]  rounded-lg shadow-xl bg-white z-10"
                        : "hidden"
                    }>
                    {filteredManagerOptions.map((option, index) => (
                      <div
                        className="bg-white cursor-pointer p-[0.5rem] hover:bg-cyan-200 transition duration-[0.3s]"
                        onClick={() => {
                          setSelectedManagerName(option.manager_name);
                          setOwedManager(option.manager_name);
                        }}
                        key={index}>
                        {option.manager_name}
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <div className="relative md:flex justify-start items-center mt-6">
                <p className="w-[30%]">Agent Last Name</p>
                <input
                  type="text"
                  value={owedAgent}
                  placeholder="Enter Agent Last Name"
                  onInput={(e) => {
                    console.log("e.target::::::", e.target.value);
                    handleAgentNameChange(e);
                  }}
                  className="outline-none  border border-gray-300 rounded-lg  w-[70%]   p-[0.8rem] "
                />
                {filteredAgentOptions.length > 0 && (
                  <div
                    className={
                      searchFilterOptionsShowAgent.current === true
                        ? "absolute 2xl:top-[4rem] lg:top-[4rem] lg:max-h-[12rem] xl:top-[4rem] xl:max-h-[12rem] 2xl:max-h-[13rem] overflow-y-scroll w-[100%]  rounded-lg shadow-xl bg-white z-10"
                        : "hidden"
                    }>
                    {filteredAgentOptions.map((option, index) => (
                      <div
                        className="bg-white cursor-pointer p-[0.5rem] hover:bg-cyan-200 transition duration-[0.3s]"
                        onClick={() => {
                          console.log("option.agent_name::", option.agent_name);
                          setOwedAgent(option.agent_name);
                          setSelectedAgentName(option.agent_name);
                        }}
                        key={index}>
                        {option.agent_name}
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <div className="md:flex justify-start items-center mt-6">
                <p className="w-[25rem]">Loan Closed After </p>
                <input
                  value={owedLoanAfter}
                  onChange={(e) => setOwedLoanAfter(e.target.value)}
                  type="date"
                  className="outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0"
                />
              </div>
              <div className="md:flex justify-start items-center mt-6">
                <p className="w-[25rem]">Loan Closed Before </p>
                <input
                  value={owedLoanBefore}
                  onChange={(e) => setOwedLoanBefore(e.target.value)}
                  type="date"
                  className="outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0"
                />
              </div>
              <div className="flex justify-start items-center space-x-4">
                <button
                  onClick={() => {
                    setOwedAgent("");
                    setOwedManager("");

                    setAgentNameForApi("");
                    setManagerNameForApi("");
                  }}
                  style={{ backgroundColor: coloredTheme }}
                  className="flex justify-center items-center  rounded space-x-2 px-[1rem] py-[0.5rem] mt-6 text-white">
                  <FaUndo />
                  <p>Reset</p>
                </button>
                <button
                  onClick={() => getStampClaimListApi()}
                  style={{ backgroundColor: coloredTheme }}
                  className="flex justify-center items-center  rounded space-x-2 px-[1rem] py-[0.5rem] mt-6 text-white">
                  <FaUndo />
                  <p>Search</p>
                </button>
              </div>
            </div>

            <div className="mt-8 bg-white pb-[1.5rem]">
              <div className="overflow-scroll px-[0.5rem]">
                <table className="md:w-[100%] xl:w-[110%] w-[180%] ">
                  <thead className="h-[6vh]">
                    <tr className="border border-gray-400">
                      {userDataFromStorage.user_role === "admin" && (
                        <th className="text-center border-r  border-gray-400 px-[0.2rem]">
                          Manager
                        </th>
                      )}
                      <th className="text-center border-r  border-gray-400 px-[0.2rem]">
                        Agent
                      </th>
                      <th className="text-center border-r  border-gray-400 px-[0.2rem]">
                        Stamp Commission
                      </th>
                      <th className="text-center border-r  border-gray-400 px-[0.2rem]"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {owedByAgentData.length
                      ? owedByAgentData.map((x, index) => {
                          return (
                            <tr key={index} className="border border-gray-400">
                              {userDataFromStorage.user_role === "admin" && (
                                <td className="text-center border-t border-r border-gray-400 px-[0.2rem]">
                                  {x.manager_name}
                                </td>
                              )}
                              <td className="text-center border-l border-t border-r border-gray-400 px-[0.2rem]">
                                {x.agent_name}
                              </td>
                              <td className="text-center border-t border-r border-gray-400 px-[0.2rem]">
                                MYR {""}
                                {x.stamp_commission}
                              </td>
                              <td className="text-center border-t border-r border-gray-400 px-[0.2rem]">
                                <button
                                  onClick={() => {
                                    setOwedToAgentModel(true);
                                    setOwedToAgentModalData(x);
                                  }}
                                  style={{ backgroundColor: coloredTheme }}
                                  className="px-[1rem] py-[0.5rem] rounded text-white ">
                                  Pay Commission
                                </button>
                              </td>
                            </tr>
                          );
                        })
                      : ""}
                  </tbody>
                </table>
              </div>
              {/* PAGINATION */}
              <div className="flex justify-end space-x-4 items-center mt-4  h-[50%]">
                <button
                  className=" px-6 py-2 rounded-lg text-white bg-gray-400 hover:bg-gray-200 shadow-xl hover:text-gray-600 transition duration-[0.5s] tracking-wider"
                  onClick={() => setCurrentPage(currentPage - 1)}
                  disabled={currentPage === 1}>
                  Prev
                </button>
                <button
                  className=" px-6 py-2 rounded-lg text-white bg-gray-400 hover:bg-gray-200 shadow-xl hover:text-gray-600 transition duration-[0.5s] tracking-wider"
                  onClick={() => setCurrentPage(currentPage + 1)}>
                  Next
                </button>
              </div>
            </div>
          </>
        ) : tabCount === 3 ? (
          <>
            <div
              style={{ backgroundColor: coloredTheme }}
              className="px-[0.5rem] md:text-[1rem] text-[0.8rem] py-[1rem]  text-white space-y-2">
              <p>
                Stamp Commission Paid to Agent. Total Stamp Commission in Report
                is MYR{" "}
              </p>
            </div>
            <div className="px-[0.5rem] py-[1rem]  bg-white">
              <div className="md:flex justify-start items-center ">
                <p className="w-[25rem]">Manager Last Name</p>
                <input
                  type="text"
                  className="outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0"
                />
              </div>
              <div className="md:flex justify-start items-center mt-6">
                <p className="w-[25rem]">Agent Last Name </p>
                <input
                  type="text"
                  className="outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0"
                />
              </div>
              <div className="md:flex justify-start items-center mt-6">
                <p className="w-[25rem]">Stamp Duty Paif From </p>
                <input
                  type="date"
                  className="outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0"
                />
              </div>
              <div className="md:flex justify-start items-center mt-6">
                <p className="w-[25rem]">Stamp Duty Paid To</p>
                <input
                  type="date"
                  className="outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0"
                />
              </div>
              <button
                style={{ backgroundColor: coloredTheme }}
                className="flex justify-center items-center rounded space-x-2 px-[1rem] py-[0.5rem] mt-6 text-white">
                <FaUndo />
                <p>Reset</p>
              </button>
            </div>
            <div className="mt-8 bg-white pb-[1.5rem]">
              <div className="overflow-scroll px-[0.5rem]">
                <table className="md:w-[100%] xl:w-[110%] w-[180%] ">
                  <thead className="h-[6vh]">
                    <tr className="border border-gray-400">
                      <th className="text-start border-r  border-gray-400 px-[0.2rem]">
                        Manager's Name
                      </th>
                      <th className="text-start border-r  border-gray-400 px-[0.2rem]">
                        Agent Name
                      </th>
                      <th className="text-start border-r  border-gray-400 px-[0.2rem]">
                        Customer Nickname
                      </th>
                      <th className="text-start border-r  border-gray-400 px-[0.2rem]">
                        Loan Number
                      </th>
                      <th className="text-start border-r  border-gray-400 px-[0.2rem]">
                        Loan Amount
                      </th>
                      <th className="text-start border-r  border-gray-400 px-[0.2rem]">
                        Commission Amount Paid
                      </th>
                      <th className="text-start border-r  border-gray-400 px-[0.2rem]">
                        Date Stamp Commission Paid
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {owedByAgentData.length
                      ? owedByAgentData.map((x, index) => {
                          let date = new Date(x?.date_commission_paid);
                          let day = String(date?.getUTCDate()).padStart(2, "0");
                          let month = String(date?.getUTCMonth() + 1).padStart(
                            2,
                            "0"
                          );
                          let year = String(date?.getUTCFullYear());
                          let modifiedLoanStartDate = `${day}-${month}-${year}`;

                          return (
                            <tr key={index} className="border border-gray-400">
                              <td className="text-start border-l border-t border-r border-gray-400 px-[0.2rem]">
                                {x.manager}
                              </td>
                              <td className="text-start border-l border-t border-r border-gray-400 px-[0.2rem]">
                                {x.agent}
                              </td>
                              <td className="text-start border-t border-r border-gray-400 px-[0.2rem]">
                                {x.customer_nickname}
                              </td>
                              <td className="text-start border-t border-r border-gray-400 px-[0.2rem]">
                                {x.loan_number}
                              </td>
                              <td className="text-start border-t border-r border-gray-400 px-[0.2rem]">
                                MYR {x.loan_amount}
                              </td>
                              <td className="text-start border-t border-r border-gray-400 px-[0.2rem]">
                                MYR {x.agent_stamp_commission}
                              </td>
                              <td className="text-start border-t border-r border-gray-400 px-[0.2rem]">
                                {modifiedLoanStartDate}
                              </td>
                            </tr>
                          );
                        })
                      : ""}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        ) : (
          <>
            <div
              style={{ backgroundColor: coloredTheme }}
              className="px-[0.5rem] md:text-[1rem] text-[0.8rem] py-[1rem]  text-white space-y-2">
              <p> Claims By Agents. Total Claims in the report is MYR </p>
            </div>
            <div className="px-[0.5rem] py-[1rem]  bg-white">
              <div className="md:flex justify-start items-center ">
                <p className="w-[25rem]">Manager Last Name</p>
                <input
                  type="text"
                  className="outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0"
                />
              </div>
              <div className="md:flex justify-start items-center mt-6">
                <p className="w-[25rem]">Agent Last Name </p>
                <input
                  type="text"
                  className="outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0"
                />
              </div>
              <div className="md:flex justify-start items-center mt-6">
                <p className="w-[25rem]">Claim Date After</p>
                <input
                  type="date"
                  className="outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0"
                />
              </div>
              <div className="md:flex justify-start items-center mt-6">
                <p className="w-[25rem]">Claim Date Before </p>
                <input
                  type="date"
                  className="outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0"
                />
              </div>
              <div className="md:flex justify-start md:justify-between xl:justify-start items-center   mt-6">
                <p className="xl:w-[25rem]">Claim Type</p>
                <div className="flex flex-col md:flex-row  ">
                  <div className="mt-4 md:mt-0">
                    <input type="radio" id="Meals" />
                    <label className="ml-1 mr-4" htmlFor="Meals">
                      Meals
                    </label>
                  </div>
                  <div className="mt-4 md:mt-0">
                    <input type="radio" id="Mileage" />
                    <label className="ml-1 mr-4" htmlFor="Mileage">
                      Mileage
                    </label>
                  </div>
                  <div className="mt-4 md:mt-0">
                    <input type="radio" id="Mobile" />
                    <label className="ml-1 mr-4" htmlFor="Mobile">
                      Mobile
                    </label>
                  </div>
                  <div className="mt-4 md:mt-0">
                    <input type="radio" id="Cop" />
                    <label className="ml-1 mr-4" htmlFor="Cop">
                      Cop
                    </label>
                  </div>
                  <div className="mt-4 md:mt-0">
                    <input type="radio" id="Stationary" />
                    <label className="ml-1 mr-4" htmlFor="Stationary">
                      Stationary
                    </label>
                  </div>
                  <div className="mt-4 md:mt-0">
                    <input type="radio" id="Salary" />
                    <label className="ml-1 mr-4" htmlFor="Salary">
                      Salary
                    </label>
                  </div>
                  <div className="mt-4 md:mt-0">
                    <input type="radio" id="Other" />
                    <label className="ml-1 " htmlFor="Other">
                      Other
                    </label>
                  </div>
                </div>
              </div>
              <button
                style={{ backgroundColor: coloredTheme }}
                className="flex justify-center items-center  rounded space-x-2 px-[1rem] py-[0.5rem] mt-6 text-white">
                <FaUndo />
                <p>Reset</p>
              </button>
            </div>

            <div className="mt-8 bg-white pb-[1.5rem]">
              <div className="overflow-scroll px-[0.5rem]">
                <table className="md:w-[100%] xl:w-[100%] w-[180%] ">
                  <thead className="h-[6vh]">
                    <tr className="border border-gray-400">
                      <th className="text-start border-r  border-gray-400 px-[0.2rem]">
                        Manager's Name
                      </th>
                      <th className="text-start border-r  border-gray-400 px-[0.2rem]">
                        Agent Name
                      </th>
                      <th className="text-start border-r  border-gray-400 px-[0.2rem]">
                        Claim Date
                      </th>
                      <th className="text-start border-r  border-gray-400 px-[0.2rem]">
                        Claim Type
                      </th>
                      <th className="text-start border-r  border-gray-400 px-[0.2rem]">
                        Other Type
                      </th>
                      <th className="text-start border-r  border-gray-400 px-[0.2rem]">
                        Amount
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {owedByAgentData.length
                      ? owedByAgentData.map((x, index) => {
                          let date = new Date(x?.claim_date);
                          let day = String(date?.getUTCDate()).padStart(2, "0");
                          let month = String(date?.getUTCMonth() + 1).padStart(
                            2,
                            "0"
                          );
                          let year = String(date?.getUTCFullYear());
                          let modifiedLoanStartDate = `${day}-${month}-${year}`;

                          return (
                            <tr key={index} className="border border-gray-400">
                              <td className="text-start border-l border-t border-r border-gray-400 px-[0.2rem]">
                                {x.manager}
                              </td>
                              <td className="text-start border-l border-t border-r border-gray-400 px-[0.2rem]">
                                {x.agent}
                              </td>
                              <td className="text-start border-t border-r border-gray-400 px-[0.2rem]">
                                {modifiedLoanStartDate}
                              </td>
                              <td className="text-start border-t border-r border-gray-400 px-[0.2rem]">
                                {x.claim_type}
                              </td>
                              <td className="text-start border-t border-r border-gray-400 px-[0.2rem]">
                                {" "}
                                {x.other_type}
                              </td>
                              <td className="text-start border-t border-r border-gray-400 px-[0.2rem]">
                                MYR {x.claim_amount}
                              </td>
                            </tr>
                          );
                        })
                      : ""}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        )}
      </div>

      <Modal
        open={owedToAgentModel}
        onClose={() => setOwedToAgentModel(false)}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        className="flex justify-center items-center overflow-y-scroll mb-[0.5rem]">
        <Box className="w-[50%]  rounded-lg bg-white absolute top-[8%] mb-[10rem] ">
          {owedToAgentLoading ? (
            <Loader />
          ) : (
            <>
              <div className="p-[0.5rem]">
                <p className="text-lg text-gray-800">
                  Confirm Commission Payment
                </p>
              </div>
              <Divider />

              <div className="p-[0.5rem]">
                {/* claim date (Required) */}
                <p className="text-xl">
                  Confirm to pay commission amount of MYR{" "}
                  {owedToAgentModalData.stamp_commission} to{" "}
                  {owedToAgentModalData.agent_name}
                </p>
                <div className="w-full space-x-8 mt-6">
                  <label className="text-lg w-[30%]">
                    Commission Paid Date :
                  </label>
                  <input
                    className="border border-gray-600 px-[0.5rem] py-2 rounded-lg outline-none text-gray-500 w-[70%]"
                    type={"date"}
                    // defaultValue={new Date()}
                    onChange={(e) =>
                      setOwedToAgentCommissionDate(e.target.value)
                    }
                  />
                </div>

                <div className="flex justify-end items-center space-x-4 mt-8 mb-4">
                  <button
                    style={{ backgroundColor: coloredTheme }}
                    onClick={() => setOwedToAgentModel(false)}
                    className="flex justify-center items-center space-x-2  text-purple-50 px-[1rem] py-[0.5rem] rounded  hover:bg-purple-50  hover:shadow-2xl hover:shadow-black">
                    <TbArrowBackUp />
                    <p>Cancel</p>
                  </button>
                  <button
                    style={{ backgroundColor: coloredTheme }}
                    onClick={() => addPaymentCommissionHandler()}
                    className="flex justify-center items-center space-x-2  text-green-50 px-[1rem] py-[0.5rem] rounded  hover:bg-green-50  hover:shadow-2xl hover:shadow-black ">
                    <RiSave2Fill />
                    <p>Add Claim Type</p>
                  </button>
                </div>
              </div>
            </>
          )}
        </Box>
      </Modal>
    </div>
  );
}

export default Stamp;
